import { checkIf } from 'components/form';

export function nameForm(prefix, { shouldValidate } = {}) {
  const setup = {
    fields: nameFormFields(prefix),
    labels: nameFormLabels(prefix),
    types: nameFormTypes(prefix),
    placeholders: namePlaceholders(prefix)
  };

  if (shouldValidate) {
    const givenPath = prefix + '.givenName';
    const lastPath = prefix + '.lastName';
    const isRequired = ({ field, form }) => [ !!form.$(givenPath).value || !!form.$(lastPath).value, 'A name is required' ];
    const check = typeof shouldValidate === 'function' ? shouldValidate : () => true;
    setup.validators = {
      [givenPath]: [ checkIf(check, [ isRequired ]) ],
      [lastPath]: [ checkIf(check, [ isRequired ]) ]
    };
  }

  return setup;
}

function nameFormFields(prefix) {
  return [
    prefix,
    prefix + '.title',
    prefix + '.givenName',
    prefix + '.lastName'
  ];
}

function nameFormLabels(prefix) {
  return {
    [prefix + '.title']: 'Title',
    [prefix + '.givenName']: 'Given Names',
    [prefix + '.lastName']: 'Last Name'
  };
}

function nameFormTypes(prefix) {
  return {
    [prefix + '.title']: 'select'
  };
}

function namePlaceholders(prefix) {
  return {
    [prefix + '.givenName']: 'First Middle'
  };
}